import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'app-genesys-secure-frame',
  templateUrl: './genesys-secure-frame.component.html',
  styleUrls: ['./genesys-secure-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysSecureFrameComponent implements OnChanges, AfterViewInit {
  @Input()
  content: string;

  @Input()
  frameId: string;

  @ViewChild('containerEl', { static: true })
  iFrameRef: ElementRef;

  ngAfterViewInit() {
    this._writeContentIntoFrame();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content) {
      this._writeContentIntoFrame();
    }
  }

  private _writeContentIntoFrame() {
    this.iFrameRef.nativeElement.contentWindow?.document.open();
    this.iFrameRef.nativeElement.contentWindow?.document.write(this._generateContent());
    this.iFrameRef.nativeElement.contentWindow?.document.close();
  }

  private _generateContent() {
    const document = new DOMParser().parseFromString(this.content, 'text/html');
    GenesysSecureFrameComponent._changeAnchorTargetsToBlank(document);

    return `<div class="iframe-content">${document.documentElement.innerHTML}</div>`;
  }

  private static _changeAnchorTargetsToBlank(document: Document) {
    const anchors = Array.from(document.getElementsByTagName('a'));

    anchors.forEach((anchor) => {
      anchor.target = '_blank';
    });
  }
}
